import { useLocation } from 'react-router-dom';
import ictacademy1 from "../../assets/CampuLifeImages/ictacademy1.jpg"
import ictacademy2 from "../../assets/CampuLifeImages/ictacademy2.jpg"
import ictacademy3 from "../../assets/CampuLifeImages/ictacademy3.jpg"
import ictacademy4 from "../../assets/CampuLifeImages/ictacademy4.jpg"
import CampusSkillEnhanceDynamic from '../../CampusLife/CampusSharedComponent/CampusDynamicPages/CampusSkillEnhanceDynamicPage/CampusSkillEnhanceDynamic';

const ICTAcademy = () => {
    const location = useLocation();
    const pathName = String(location.pathname);
    const hoverContent =[
      {  img:ictacademy1, para1: "Address I by Mr.Thiruvengadam Viswanathan, Senior Cloud Architect on “Cloud Computing and Security”", para2:"Address II by Dr.A.Suruliandi, Associate Professor,Department of Computer Science & Engineering,M.S. University, Tirunelveli on “Big Data Analytics”" },
      {  img:ictacademy4, para1: "“Virtual Power Seminar by Ms Sangeetha, Skill Trainer from Chennai.”" },
      {  img:ictacademy2, para1: "On 14th March 2024, In  campus Placement Drive ICT Academy in Placement domain associated with  Vertical Solutions Ltd.  Chennai,  placed  67 students from various departments  as Assembly Line Operator in Fox Con Company and received the offer letters.On behalf of Management we heartily appreciate the continuous effort took by ICT Academy & Placement Cell coordinators & members. ", para2: "" },
      {  img:ictacademy3, para1: "Receiving Sanction order to conduct STP in our college from our Honorable Minister MANAO THANGARAJ. On 18-04-2022 at Bridge Event held at Nagercoil", para2: "" },
  ]
  
  const data = {
    pathName:pathName, 
    fourhover:true,
    name: "ICT Academy of Tamil Nadu",
     title: "ICT Academy of Tamil Nadu Activities",
     para:"We are proud to collaborate with ICT Academy of Tamil Nadu in organizing Faculty Development Programs (FDPs), student placement drives, power seminars, and conferences.",
     points:[
      {title:"Faculty Development Programs (FDPs) : ",content:" Enhancing teaching methodologies and technical expertise for educators."},
      {title:"Student Placements : ",content:"Providing students with industry-ready training and placement opportunities."},
      {title:"Power Seminars : ",content:"Engaging sessions with industry leaders to inspire and guide students toward success."},
      {title:"Conferences : ",content:"Hosting knowledge-sharing events with experts, researchers, and professionals."},
      {title:"",content:"Through this collaboration, we are committed to bridging the gap between academia and industry, fostering innovation, and empowering the next generation of professionals."},
      {title:"",content:"This partnership aims to empower students and faculty with industry-relevant skills, career opportunities, and knowledge-sharing platforms."},
     ],
    }
  return (
   <>
   
   <CampusSkillEnhanceDynamic data={data} content={hoverContent} />

   </>
    
  )
}

export default ICTAcademy


